import { motion } from "framer-motion";
import { useState, useEffect } from "react";

const RadarScanner = ({ inView }: { inView: boolean }) => {
  const [dots, setDots] = useState<{ x: number; y: number; id: number }[]>([]);
  const [signalCount, setSignalCount] = useState(0);

  useEffect(() => {
    if (!inView) return;
    let id = 0;
    const interval = setInterval(() => {
      const angle = Math.random() * Math.PI * 2;
      const r = 20 + Math.random() * 60;
      setDots((prev) => [
        ...prev.slice(-12),
        { x: 50 + Math.cos(angle) * r * 0.4, y: 50 + Math.sin(angle) * r * 0.4, id: id++ },
      ]);
      setSignalCount((c) => c + 1);
    }, 400);
    return () => clearInterval(interval);
  }, [inView]);

  return (
    <div className="relative w-full aspect-square max-w-[280px] mx-auto">
      {/* Concentric rings */}
      {[1, 2, 3].map((ring) => (
        <motion.div
          key={ring}
          className="absolute rounded-full border border-primary/10"
          style={{
            width: `${ring * 33}%`,
            height: `${ring * 33}%`,
            top: `${50 - ring * 16.5}%`,
            left: `${50 - ring * 16.5}%`,
          }}
          animate={inView ? {
            opacity: [0.1, 0.3, 0.1],
            scale: [1, 1.02, 1],
          } : {}}
          transition={{
            duration: 2,
            repeat: Infinity,
            delay: ring * 0.3,
          }}
        />
      ))}

      {/* Sweep line */}
      <motion.div
        className="absolute top-1/2 left-1/2 origin-left h-px w-1/2"
        style={{ background: "linear-gradient(90deg, hsl(var(--primary) / 0.8), transparent)" }}
        animate={inView ? { rotate: 360 } : {}}
        transition={{ duration: 3, repeat: Infinity, ease: "linear" }}
      />

      {/* Center dot */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-2 h-2 rounded-full bg-primary animate-pulse-glow" />

      {/* Detected signal dots */}
      {dots.map((dot) => (
        <motion.div
          key={dot.id}
          className="absolute w-1.5 h-1.5 rounded-full bg-primary"
          style={{ left: `${dot.x}%`, top: `${dot.y}%` }}
          initial={{ opacity: 0, scale: 0 }}
          animate={{ opacity: [0, 1, 0.3], scale: [0, 1.5, 1] }}
          transition={{ duration: 2 }}
        />
      ))}

      {/* Stats overlay */}
      <div className="absolute bottom-0 left-0 right-0 flex justify-center gap-3">
        <span className="px-2 py-1 rounded text-[10px] font-data bg-primary/10 text-primary border border-primary/20">
          {signalCount > 47 ? 47 : signalCount} signals
        </span>
        <span className="px-2 py-1 rounded text-[10px] font-data bg-primary/10 text-primary border border-primary/20">
          {"< 50ms"}
        </span>
      </div>
    </div>
  );
};

export default RadarScanner;
